import { defineStore } from 'pinia'
import { computed, ref } from 'vue'
import axios from 'axios'
import { subtotalStore } from '@/stores/v2/subtotal'
import { notification } from 'ant-design-vue'
import { ExtraElement } from '@/types/v2/extra/extraElement'
import { ExtraProduct } from '@/types/v2/extra/extraProduct'

export const extraStore = defineStore('v2/extra', () => {
  const loading = ref(false)
  const saving = computed(() => savingProductId.value > 0)
  const savingProductId = ref(0)

  const elements = ref<ExtraElement[]>([])

  const hasSelectedProducts = computed(() =>
    elements.value
      .flatMap(element => element.products)
      .filter(product => product.selected &&
        !product.is_ordered &&
        (!product.closes_at || new Date(product.closes_at) > new Date())
      ).length > 0
  )

  function getExtraProducts () : void {
    loading.value = true
    axios.get(process.env.VUE_APP_API_URL_V2 + '/extra').then((r) => {
      elements.value = r.data
    }).finally(() => {
      loading.value = false
      checkForUnorderedClosedOptions()
    })
  }

  function toggleProduct (id:number, qty:number) : void {
    savingProductId.value = id
    axios.post(process.env.VUE_APP_API_URL_V2 + '/extra/' + id, { qty: qty }).then((r) => {
      elements.value = r.data
    }).finally(() => {
      subtotalStore().getSubtotals()
      savingProductId.value = 0
    })
  }

  function updateProductQty (product:ExtraProduct, qty:number) : void {
    if (product.selected && qty) {
      savingProductId.value = product.id
      axios.patch(process.env.VUE_APP_API_URL_V2 + '/extra/' + product.id, { qty: qty }).then((r) => {
        elements.value = r.data
        notification.success({
          message: 'Aantal succesvol aangepast.',
          description: 'Het aantal van "' + product.commercial_name + '" is succesvol aangepast naar ' + qty + '.',
          duration: 5
        })
      }).catch(() => {
        notification.error({
          message: 'Aantal niet aangepast!',
          description: 'Het aantal van "' + product.commercial_name + '" is NIET aangepast. Probeer het later nog een keer.'
        })
      }).finally(() => {
        subtotalStore().getSubtotals()
        savingProductId.value = 0
      })
    }
  }

  function checkForUnorderedClosedOptions () : void {
    if (!elements.value || !elements.value.length) return

    loading.value = true
    elements.value.forEach((element:ExtraElement) => {
      element.products.forEach((product:ExtraProduct) => {
        if (product.selected && !product.is_ordered && product.closes_at && new Date(product.closes_at) < new Date()) {
          toggleProduct(product.id, 0)
        }
      })
    })
    loading.value = false
  }

  return {
    loading,
    saving,
    savingProductId,
    elements,
    hasSelectedProducts,
    getExtraProducts,
    toggleProduct,
    updateProductQty
  }
})
